// Mock data for YouTube clone

export const categoryChips = [
  'Shared', 'Nearby', 'Random', 'Search', 'Notifications'
];

export const channels = {
  ch1: { id: 'ch1', name: 'Rick Astley', handle: '@RickAstleyYT', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_kgi0lPhEbiBO5K0ChCpZtDQTV0_7yL3qOX6_xsCl6XiQ=s176-c-k-c0x00ffffff-no-rj', subscribers: '4.2M', verified: true },
  ch2: { id: 'ch2', name: 'jawed', handle: '@jawed', avatar: 'https://yt3.ggpht.com/a/AATXAJxJR8q_bhPI5o2-Pe4fvxV8WDw3yegmhOYRoA=s176-c-k-c0xffffffff-no-rj-mo', subscribers: '2.7M', verified: false },
  ch3: { id: 'ch3', name: 'officialpsy', handle: '@officialpsy', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_klP2LR_ZMYR9jTu-0PpjW3IJzYZPjz5fFyEFhKRpNHQg=s176-c-k-c0x00ffffff-no-rj', subscribers: '19.8M', verified: true },
  ch4: { id: 'ch4', name: 'Luis Fonsi', handle: '@LuisFonsiVEVO', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_lk-Dje2YtN_3yJp_EJZxVL26ZWJfP9dRmQGVhktWaiAg=s176-c-k-c0x00ffffff-no-rj', subscribers: '34.1M', verified: true },
  ch5: { id: 'ch5', name: 'Wiz Khalifa', handle: '@WizKhalifa', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_lTwZmHdEXOCMVvEy_EJWQRDXPZc0LhbsCmZHV3qHvLkw=s176-c-k-c0x00ffffff-no-rj', subscribers: '15.3M', verified: true },
  ch6: { id: 'ch6', name: 'Mark Ronson', handle: '@MarkRonson', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_kCzJ9lSmM_R4M5SzKBKxJIp_Fx2Jq1AlUKyvLh3K9_iA=s176-c-k-c0x00ffffff-no-rj', subscribers: '5.8M', verified: true },
  ch7: { id: 'ch7', name: 'Ed Sheeran', handle: '@EdSheeran', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_l8XR_9G2bv7d3-GNJOewCqDC3Y3FxFmREkJnJMWBP1aA=s176-c-k-c0x00ffffff-no-rj', subscribers: '54.2M', verified: true },
  ch8: { id: 'ch8', name: 'Queen Official', handle: '@QueenOfficial', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_kdFnZdCl8DbYLpQmZ5Cw0jcdOMIspPZOTjKRpNn5TLxA=s176-c-k-c0x00ffffff-no-rj', subscribers: '15.6M', verified: true },
  ch9: { id: 'ch9', name: 'OneRepublic', handle: '@OneRepublic', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_kkJWxFkQvL6S4pPKzXC0G9bH9_J1NgMRJF3xnAuIAOKw=s176-c-k-c0x00ffffff-no-rj', subscribers: '11.4M', verified: true },
  ch10: { id: 'ch10', name: 'Adele', handle: '@Adele', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_kQJ4OXBjZLk5YE6CUYI8kQyUy7n4TJzn_7DjgyTGMZag=s176-c-k-c0x00ffffff-no-rj', subscribers: '32.5M', verified: true },
  ch11: { id: 'ch11', name: 'Maroon 5', handle: '@Maroon5', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_lfX3pV5e5k0WO8b8xLOYNjwLvY7tNg-vEeIqrKD1RpKw=s176-c-k-c0x00ffffff-no-rj', subscribers: '38.6M', verified: true },
  ch12: { id: 'ch12', name: 'Alan Walker', handle: '@AlanWalker', avatar: 'https://yt3.googleusercontent.com/ytc/AIdro_l7wM7VXGv6YO5_5jL1_z48aL8IwOkbQ4SZAnmGXTw1Vw=s176-c-k-c0x00ffffff-no-rj', subscribers: '43.1M', verified: true }
};

export const videos = [
  {
    id: 'dQw4w9WgXcQ',
    title: 'Rick Astley - Never Gonna Give You Up (Official Music Video)',
    channelId: 'ch1',
    views: '1.6B views',
    viewCount: 1600000000,
    uploaded: '15 years ago',
    duration: '3:33',
    description: 'The official video for “Never Gonna Give You Up” by Rick Astley. The song was a global smash on its release in 1987, topping the charts in 25 countries including the UK and the US Billboard Hot 100.',
    likes: '18M',
    category: 'Music'
  },
  {
    id: 'jNQXAC9IVRw',
    title: 'Me at the zoo',
    channelId: 'ch2',
    views: '348M views',
    viewCount: 348000000,
    uploaded: '20 years ago',
    duration: '0:18',
    description: 'The first video on YouTube. While you wait for Part Two, listen to this great song: https://www.youtube.com/watch?v=zj82_v2R6ts',
    likes: '15M',
    category: 'All'
  },
  {
    id: '9bZkp7q19f0',
    title: 'PSY - GANGNAM STYLE(강남스타일) M/V',
    channelId: 'ch3',
    views: '5.3B views',
    viewCount: 5300000000,
    uploaded: '12 years ago',
    duration: '4:13',
    description: 'PSY - ‘GANGNAM STYLE(강남스타일)’ M/V',
    likes: '30M',
    category: 'Music'
  },
  {
    id: 'kJQP7kiw5Fk',
    title: 'Luis Fonsi - Despacito ft. Daddy Yankee',
    channelId: 'ch4',
    views: '8.6B views',
    viewCount: 8600000000,
    uploaded: '8 years ago',
    duration: '4:42',
    description: '“Despacito” disponible ya en todas las plataformas digitales',
    likes: '54M',
    category: 'Music'
  },
  {
    id: 'RgKAFK5djSk',
    title: 'Wiz Khalifa - See You Again ft. Charlie Puth [Official Video] Furious 7 Soundtrack',
    channelId: 'ch5',
    views: '6.5B views',
    viewCount: 6500000000,
    uploaded: '10 years ago',
    duration: '3:57',
    description: 'Wiz Khalifa - See You Again ft. Charlie Puth [Official Video] Furious 7 Soundtrack.',
    likes: '42M',
    category: 'Music'
  },
  {
    id: 'OPf0YbXqDm0',
    title: 'Mark Ronson - Uptown Funk (Official Video) ft. Bruno Mars',
    channelId: 'ch6',
    views: '5.6B views',
    viewCount: 5600000000,
    uploaded: '10 years ago',
    duration: '4:31',
    description: 'Official video for Uptown Funk by Mark Ronson ft. Bruno Mars',
    likes: '25M',
    category: 'Music'
  },
  {
    id: 'JGwWNGJdvx8',
    title: 'Ed Sheeran - Shape of You (Official Music Video)',
    channelId: 'ch7',
    views: '6.4B views',
    viewCount: 6400000000,
    uploaded: '8 years ago',
    duration: '4:24',
    description: 'The official music video for Ed Sheeran - Shape Of You',
    likes: '32M',
    category: 'Music'
  },
  {
    id: 'fJ9rUzIMcZQ',
    title: 'Queen – Bohemian Rhapsody (Official Video Remastered)',
    channelId: 'ch8',
    views: '1.8B views',
    viewCount: 1800000000,
    uploaded: '7 years ago',
    duration: '5:59',
    description: 'REMASTERED IN HD TO CELEBRATE ONE BILLION VIEWS!',
    likes: '14M',
    category: 'Music'
  },
  {
    id: 'hT_nvWreIhg',
    title: 'OneRepublic - Counting Stars (Official Music Video)',
    channelId: 'ch9',
    views: '4.2B views',
    viewCount: 4200000000,
    uploaded: '11 years ago',
    duration: '4:43',
    description: 'OneRepublic’s official music video for ‘Counting Stars’.',
    likes: '28M',
    category: 'Music'
  },
  {
    id: 'YQHsXMglC9A',
    title: 'Adele - Hello',
    channelId: 'ch10',
    views: '3.5B views',
    viewCount: 3500000000,
    uploaded: '9 years ago',
    duration: '6:07',
    description: '‘Hello’ was written by Adele and Greg Kurstin. Available now from iTunes',
    likes: '21M',
    category: 'Music'
  },
  {
    id: 'lp-EO5I60KA',
    title: 'Ed Sheeran - Thinking Out Loud (Official Music Video)',
    channelId: 'ch7',
    views: '3.7B views',
    viewCount: 3700000000,
    uploaded: '10 years ago',
    duration: '4:57',
    description: 'The official music video for Ed Sheeran - Thinking Out Loud',
    likes: '20M',
    category: 'Music'
  },
  {
    id: '09R8_2nJtjg',
    title: 'Maroon 5 - Sugar (Official Music Video)',
    channelId: 'ch11',
    views: '4.1B views',
    viewCount: 4100000000,
    uploaded: '10 years ago',
    duration: '5:02',
    description: 'Sugar by Maroon 5 from the album V',
    likes: '24M',
    category: 'Music'
  },
  {
    id: '60ItHLz5WEA',
    title: 'Alan Walker - Faded',
    channelId: 'ch12',
    views: '4.0B views',
    viewCount: 4000000000,
    uploaded: '9 years ago',
    duration: '3:33',
    description: 'Listen to / Download ‘Faded’ here',
    likes: '32M',
    category: 'Music'
  },
  {
    id: '_Yhyp-_hX2s',
    title: 'Ed Sheeran - Photograph (Official Music Video)',
    channelId: 'ch7',
    views: '1.4B views',
    viewCount: 1400000000,
    uploaded: '10 years ago',
    duration: '4:26',
    description: 'The official music video for Ed Sheeran - Photograph',
    likes: '11M',
    category: 'Music'
  },
  {
    id: 'YykjpeuMNEk',
    title: 'Hymn for the Weekend - Coldplay (Official Video)',
    channelId: 'ch9',
    views: '2.1B views',
    viewCount: 2100000000,
    uploaded: '9 years ago',
    duration: '4:21',
    description: 'Coldplay - Hymn For The Weekend',
    likes: '15M',
    category: 'Music'
  },
  {
    id: 'pRpeEdMmmQ0',
    title: 'Shakira - Waka Waka (This Time for Africa) (The Official 2010 FIFA World Cup™ Song)',
    channelId: 'ch4',
    views: '4.3B views',
    viewCount: 4300000000,
    uploaded: '14 years ago',
    duration: '3:31',
    description: 'Shakira’s official music video for ‘Waka Waka (This Time For Africa)’.',
    likes: '26M',
    category: 'Music'
  }
];

// Shorts data (vertical short-form videos)
export const shorts = [
  { id: 'jNQXAC9IVRw', title: 'Me at the zoo', channelId: 'ch2', views: '348M', likes: '15M' },
  { id: 'dQw4w9WgXcQ', title: 'Never Gonna Give You Up', channelId: 'ch1', views: '1.6B', likes: '18M' },
  { id: '9bZkp7q19f0', title: 'Gangnam Style', channelId: 'ch3', views: '5.3B', likes: '30M' },
  { id: '60ItHLz5WEA', title: 'Faded', channelId: 'ch12', views: '4B', likes: '32M' },
  { id: 'OPf0YbXqDm0', title: 'Uptown Funk', channelId: 'ch6', views: '5.6B', likes: '25M' },
  { id: 'YQHsXMglC9A', title: 'Hello', channelId: 'ch10', views: '3.5B', likes: '21M' }
];

// Comments mock
export const commentsByVideo = {
  default: [
    { id: 'c1', user: 'MusicLover92', avatar: 'https://i.pravatar.cc/40?img=1', text: 'This song never gets old. Listening in 2025 🔥', likes: '12K', time: '2 days ago' },
    { id: 'c2', user: 'Sarah K.', avatar: 'https://i.pravatar.cc/40?img=5', text: 'Who else came here from a meme?', likes: '8.4K', time: '1 week ago' },
    { id: 'c3', user: 'Mike Johnson', avatar: 'https://i.pravatar.cc/40?img=3', text: 'The production quality is just unmatched. A timeless classic.', likes: '3.2K', time: '3 days ago' },
    { id: 'c4', user: 'Anita Sharma', avatar: 'https://i.pravatar.cc/40?img=8', text: 'I remember dancing to this when I was a kid. Brings back so many memories.', likes: '1.9K', time: '5 days ago' },
    { id: 'c5', user: 'David L.', avatar: 'https://i.pravatar.cc/40?img=12', text: 'The lyrics hit different now that I’m older.', likes: '900', time: '1 month ago' },
    { id: 'c6', user: 'Priya R.', avatar: 'https://i.pravatar.cc/40?img=20', text: 'YouTube’s algorithm brought me here at 3 AM and I have no regrets.', likes: '2.1K', time: '2 weeks ago' }
  ]
};

export const subscriptions = ['ch1', 'ch3', 'ch4', 'ch7', 'ch9', 'ch10', 'ch11', 'ch12'];

export const getVideoById = (id) => videos.find(v => v.id === id);
export const getChannelById = (id) => channels[id];
export const getThumbnail = (id, quality = 'hqdefault') => `https://i.ytimg.com/vi/${id}/${quality}.jpg`;
